import React from 'react';
import { notification } from 'antd';
const isRecord = (value) => {
    return typeof value === 'object' && value !== null;
};
export const creditCardErrorRender = (props) => {
    const { error, store, showNotification = true } = props;
    const responseData = error?.response?.data;
    const creditCardErrors = isRecord(responseData) ? responseData['Credit Card'] : undefined;
    if (error?.response?.status === 400 && Array.isArray(creditCardErrors)) {
        const getFormatErrors = creditCardErrors.map((item) => {
            switch (item.code) {
                case 'CVV_FAILURE':
                    return React.createElement("li", { key: 1 }, "CVV value is invalid.");
                case 'ADDRESS_VERIFICATION_FAILURE':
                    return React.createElement("li", { key: 2 }, "Postal code is invalid.");
                case 'INVALID_EXPIRATION':
                    return React.createElement("li", { key: 3 }, "Expiration date is invalid.");
                case 'INSUFFICIENT_FUNDS':
                    return React.createElement("li", { key: 4 }, "Insufficient funds to cover the payment.");
                default:
                    return (React.createElement("li", { key: 5 }, "Card was declined without any additional information, if the payment information seems correct, contact the issuer to ask for more information."));
            }
        });
        if (showNotification) {
            notification.error({
                duration: 10,
                message: 'Payment Declined',
                description: (React.createElement("div", { className: "flex flex-col" },
                    React.createElement("ul", { style: { listStyleType: 'none', paddingLeft: 0, marginBottom: 0 } }, getFormatErrors))),
                placement: 'topRight',
            });
        }
        // Save error data in an observable property. Example: QuickTurnPartStore.setCreditCardError(getFormatErrors)
        if (store) {
            store?.setCreditCardError(getFormatErrors);
        }
    }
};
